"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = theme => ({
  menu: {
    boxShadow: theme.menu.boxShadow,
    color: 'inherit',
    backgroundColor: theme.menu.bgColor,
    minWidth: 160,
    maxWidth: 320,
    overflowX: 'hidden',
    overflowY: 'auto',
    maxHeight: '50vh',
    '&.disabled': {
      opacity: theme.disabledOpacity,
      cursor: 'default'
    },
    '&.hidden': {
      maxHeight: '0vh',
      boxShadow: 'none',
      padding: 0,
      opacity: 0
    },
    '&.unspaced': {
      padding: 0
    }
  },
  small: {
    paddingTop: 4,
    paddingBottom: 4,
    borderRadius: 3
  },
  medium: {
    paddingTop: 8,
    paddingBottom: 8,
    borderRadius: 4
  },
  large: {
    paddingTop: 8,
    paddingBottom: 8,
    borderRadius: 4
  }
});
exports.default = _default;